import styled from 'styled-components';

export const ModlaStatusStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.3);
  z-index: 99;
  .conteiner {
    width: 40%;
    background: rgba(197, 197, 197, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    position: relative;
    .fecharModal {
      position: absolute;
      top: 10px;
      right: 25px;
      font-size: 30px;
      cursor: pointer;
    }
    ul {
      list-style: none;
      padding: 20px;
      width: 100%;
      gap: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      li {
        width: 60%;
        div {
          width: 100%;
          display: flex;
          justify-content: space-between;
          span {
            font-size: 20px;
            font-weight: 600;
            color: rgba(67, 67, 67, 1);
          }
        }
      }
    }
  }
`;

export const ModalAlert = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.3);
  z-index: 10;
  .conteiner {
    width: 90%;
    height: 90%;
    background: rgb(120, 117, 118);
    border-radius: 15px;
    padding: 50px 35px;
    position: relative;

    .closeBotao {
      position: absolute;
      font-size: 35px;
      right: -8px;
      top: -8px;
      cursor: pointer;
      color: rgb(238, 238, 238);
      transition: 0.5s;
    }
    .closeBotao:hover {
      color: rgb(255, 255, 255);
    }
    .headerModal {
      display: flex;
      width: 99.5%;
      justify-content: space-between;
      font-size: 20px;
      color: rgba(255, 255, 255, 1);
      font-weight: 600;
      margin-bottom: 25px;

      span {
        text-align: center;
        width: 75px;
        width: 100%;
      }
    }
    ul {
      overflow-y: scroll;
      width: 100%;
      height: 90%;
      display: flex;
      flex-direction: column;
      gap: 20px;
      scrollbar-width: thin;
      scrollbar-color: rgba(100, 100, 100, 0.8) rgba(100, 100, 100, 0);
      li {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        border-bottom: 2px solid rgba(87, 87, 87, 1);
        span {
          text-align: center;
          width: 100%;
        }
      }
    }
    .setasPaginacao {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin: 5px;
      .disable {
        opacity: 0.2;
        cursor: no-drop;
      }
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        font-size: 20px;
        transition: 0.5s;
        background: var(--branco);
        border-radius: 3px;
        cursor: pointer;
        color: var(--cor-primaria);
        font-weight: bold;
        border: 2px solid var(--cor-primaria);
      }
      button:hover {
        background-color: var(--cor-primaria);
        color: var(--branco);
        border: 2px solid var(--cor-primaria);
        box-shadow: 2px 2px 10px var(--shadow);
      }
    }
  }
`;

export const ModalConfirmController = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.4);
  z-index: 99;
  .deleteContact {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 600px;
    max-width: 80%;
    background-color: rgba(18, 18, 20, 0.9);
    border: 2px solid #b2b2b2;
    padding: 20px;
    border-radius: 15px;
    gap: 15px;
    h2 {
      color: white;
    }
    div {
      display: flex;
      gap: 15px;
      width: 100%;
      button {
        width: 100%;
        height: 50px;
        font-size: 1rem;
        font-family: 'Inter', sans-serif;
        color: #ffffff;
        border: none;
        background-color: rgba(195, 13, 26, 1);
        border-radius: 8px;
        cursor: pointer;
      }
      .buttonYes {
        background-color: transparent;
        color: rgba(1, 255, 24, 1);
        border: 2px solid rgba(1, 255, 24, 1);
        transition: 1s;
      }
      .buttonYes:hover {
        background-color: rgba(5, 164, 21, 1);
        color: white;
      }
    }
  }
`;

export const ModalCreatingUser = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.53);
  backdrop-filter: blur(2px);
  z-index: 99;
  .error {
    color: red;
  }
  form {
    border: 2px solid rgba(125, 125, 125, 1);
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 400px;
    max-width: 95%;
    background: rgba(0, 0, 0, 0.2);
    box-shadow: 0 0px 30px 0 rgba(232, 232, 232, 0.1);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    list-style: none;
    padding: 15px;
    position: relative;
    color: rgba(208, 208, 208, 1);
    .closeModal {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 30px;
      cursor: pointer;
      transition: 0.5s;
      color: rgba(208, 208, 208, 1);
    }
    .closeModal:hover {
      color: rgba(255, 255, 255, 1);
    }
    ul {
      display: flex;
      flex-direction: column;
      gap: 25px;
      list-style: none;
      li {
        display: flex;
        flex-direction: column;
        position: relative;
        label {
          font-weight: 600;
          color: rgb(255, 255, 255);
          max-width: max-content;
          padding: 0px 4px;
          position: absolute;
          top: -10px;
          left: 15px;
          background: rgb(73, 73, 73);
          background: linear-gradient(
            0deg,
            rgba(73, 73, 73, 0) 20%,
            rgba(73, 73, 73, 0.9051995798319328) 30%,
            rgba(237, 237, 237, 0) 80%
          );
          /* opacity: 85%; */
        }
        input {
          padding: 15px 20px;
          border-radius: 15px;
          border: 1px solid black;
          background-color: rgba(106, 106, 106, 0.4);
          box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -moz-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          color: rgba(255, 255, 255, 1);
        }
        .viewPassword {
          position: absolute;
          right: 10px;
          top: 15px;
          cursor: pointer;
        }
      }
      .redioInput {
        gap: 10px;
        label {
          position: relative;
        }
        .radio-container:checked {
          background-color: black;
          border-color: black;
        }
      }
    }
    button {
      height: 45px;
      border-radius: 10px;
      border: 2px solid rgba(76, 76, 76, 1);
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      color: rgba(255, 255, 255, 1);
      background-color: rgba(106, 106, 106, 0.4);
      transition: 1s;
      box-shadow: -7px 28px 67px -20px rgba(0, 0, 0, 0.75);
      -webkit-box-shadow: -7px 28px 67px -20px rgba(0, 0, 0, 0.75);
      -moz-box-shadow: -7px 28px 67px -20px rgba(0, 0, 0, 0.75);
    }
    button:hover {
      background-color: rgba(27, 27, 27, 1);
    }
  }
`;

export const ModalValulaStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.5);
  z-index: 99;
  .conteiner {
    display: flex;
    background-color: rgba(209, 209, 209, 0.95);
    flex-direction: column;
    padding: 20px;
    gap: 20px;
    border-radius: 15px;
    justify-content: center;
    align-items: center;
    .range {
      display: flex;
      gap: 10px;
      width: 70%;
      align-items: center;
      input {
        -webkit-appearance: none;
        width: 100%;
        height: 10px;
        border-radius: 5px;
        background: rgba(74, 74, 74, 1);
        outline: none;

        &::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: rgba(103, 103, 103, 1);
          cursor: pointer;
        }
      }
      span {
        font-size: 18px;
        font-weight: 600;
      }
    }
    .buttons {
      display: flex;
      gap: 15px;
      button {
        width: 200px;
        height: 35px;
        cursor: pointer;
        border-radius: 5px;
        border: 2px solid rgba(87, 87, 87, 1);
        font-weight: 600;
      }
      .cancel {
        background-color: rgba(87, 87, 87, 1);
        color: rgba(191, 191, 191, 1);
      }
      .cancel:hover {
        border: 2px;
        border: 2px solid rgba(180, 180, 180, 1);
      }
    }
  }
`;

export const ModalCreatingTanque = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.5);
  z-index: 99;
  form {
    border: 2px solid rgba(125, 125, 125, 1);
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 400px;
    max-width: 95%;
    background-color: rgba(222, 222, 222, 0.9);
    box-shadow: 0 3px 20px 0 rgba(31, 38, 135, 0.2);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    list-style: none;
    padding: 15px;
    position: relative;
    .closeModal {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 30px;
      cursor: pointer;
      transition: 0.5s;
      color: rgba(118, 118, 118, 1);
    }
    .closeModal:hover {
      color: rgba(0, 0, 0, 1);
    }
    ul {
      display: flex;
      flex-direction: column;
      gap: 25px;
      list-style: none;
      li {
        display: flex;
        flex-direction: column;
        position: relative;
        label {
          font-weight: 600;
          color: rgba(62, 62, 62, 1);
          background: linear-gradient(to top, rgba(222, 222, 222, 1) 50%, transparent 50%);
          max-width: max-content;
          padding: 0px 4px;
          position: absolute;
          top: -10px;
          left: 15px;
          text-shadow: -1px -2px 8px rgba(255, 255, 255, 0.8);
        }
        input {
          padding: 15px 20px;
          border-radius: 15px;
          border: 1px solid black;
          background-color: rgba(222, 222, 222, 1);
          box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -moz-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
        }
        select {
          padding: 15px 20px;
          border-radius: 15px;
          border: 1px solid black;
          background-color: rgba(222, 222, 222, 1);
          box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
          -moz-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
        }
      }
    }
    button {
      height: 45px;
      border-radius: 10px;
      border: 2px solid rgba(76, 76, 76, 1);
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      color: rgba(83, 83, 83, 1);
      background: rgba(198, 198, 198, 1);
      transition: 1s;
      box-shadow: -7px 28px 67px -20px rgba(0, 0, 0, 0.75);
      -webkit-box-shadow: -7px 28px 67px -20px rgba(0, 0, 0, 0.75);
      -moz-box-shadow: -7px 28px 67px -20px rgba(0, 0, 0, 0.75);
    }
    button:hover {
      background-color: rgba(222, 222, 222, 1);
    }
  }
`;

export const StyledModalVazao = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(18, 18, 20, 0.3);
  z-index: 10;
  .conteiner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 15px;
    align-items: center;
    gap: 15px;
    width: 600px;
    min-width: 350px;
    height: 250px;
    background-color: aqua;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.5);
    position: relative;
    .inpultDiv {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;
      width: 100%;
      font-weight: 600;
      .inpulVazao {
        width: 50%;
        cursor: pointer;
        -webkit-appearance: none;
        background: transparent;
      }
      /* trilha */
      .inpulVazao::-webkit-slider-runnable-track {
        height: 8px;
        background: #5a5a5a; /* cor da barra */
        border-radius: 5px;
      }

      /* botão */
      .inpulVazao::-webkit-slider-thumb {
        -webkit-appearance: none;
        height: 18px;
        width: 18px;
        border-radius: 50%;
        background: #d6d6d6; /* cor do botão */
        margin-top: -5px;
        cursor: pointer;
      }

      /* Firefox */
      .inpulVazao::-moz-range-track {
        height: 8px;
        background: #4caf50;
        border-radius: 5px;
      }

      .inpulVazao::-moz-range-thumb {
        height: 18px;
        width: 18px;
        border-radius: 50%;
        background: #7c7c7c;
        border: none;
        cursor: pointer;
      }
    }
    .closeModal {
      font-size: 25px;
      position: absolute;
      top: -8px;
      right: -8px;
      color: white;
      background-color: black;
      border-radius: 50%;
      cursor: pointer;
    }
    background: -moz-linear-gradient(
      0deg,
      rgba(140, 140, 140, 0.6) 0%,
      rgba(237, 237, 237, 0.6) 100%
    );
    background: -webkit-linear-gradient(
      0deg,
      rgba(140, 140, 140, 0.6) 0%,
      rgba(237, 237, 237, 0.6) 100%
    );
    background: linear-gradient(0deg, rgba(140, 140, 140, 0.96) 0%, rgba(237, 237, 237, 0.99) 100%);
    border: 2px solid rgba(57, 57, 57, 1);
    border-radius: 4px;
    button {
      font-size: 18px;
      font-weight: 600;
      max-height: 100%;
      background-color: var(--bgBotao);
      color: black;
      border-radius: 10px;
      border: 1px solid rgb(0, 0, 0);
      padding: 5px 30px;
      cursor: pointer;
    }
  }
`;
